module.exports = __webpack_public_path__ + "static/media/banner-right-circle.81a1856d.png";